import { SelectProps } from '@amzn/awsui-components-core';
import React from 'react';
import constants from '../../common/constants';
import UserProfile from '../../model/UserProfile';
import MetadataSelectInput from '../workflow-viewer/content/MetadataSelectInput';

interface Props {
  formId: string;
  contentId: string;
  techWriterId: string;
  techWriters: UserProfile[];
  onTechWriterAssignmentUpdate?: (techWriterId: string) => void;
}

interface State {
  selectedTechWriterId: string;
}

class AssignTechWriterForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedTechWriterId: this.props.techWriterId,
    };
  }

  public render() {
    const { selectedTechWriterId } = this.state;
    const { techWriters } = this.props;
    const selectOptions: SelectProps.Option[] = techWriters.map((techWriter) => {
      return {
        id: techWriter.userId,
        label: techWriter.name,
        value: techWriter.userId,
      };
    });
    return (
      <div className="awsui">
        <MetadataSelectInput
          sectionId="techWriter"
          label={constants.ASSIGN_TECH_WRITER}
          selectedId={selectedTechWriterId}
          selectOptions={selectOptions}
          onSelectUpdated={this.handleTechWriterAssignmentChanged}
          stretch
          placeholder={constants.SELECT_TECH_WRITER}
        />
      </div>
    );
  }

  private handleTechWriterAssignmentChanged = (
    sectionId: string,
    selectedId: string,
    validationError?: string,
  ) => {
    const selectedTechWriterId = selectedId;
    this.setState({ selectedTechWriterId });
    // @ts-expect-error TS2722 - strict migration
    this.props.onTechWriterAssignmentUpdate(selectedTechWriterId);
  };
}

export default AssignTechWriterForm;
